export const CHAPTER_EVENTS = {
  USER_ENTER: 'Fc_chapter_user_enter',
  USER_LEAVE: 'Fc_chapter_user_leave',
  USER_MARK: 'Fc_chapter_user_mark',
}
